import { render } from "./SpareCompaign.vue?vue&type=template&id=60eb22ba"
import script from "./SpareCompaign.vue?vue&type=script&lang=js"
export * from "./SpareCompaign.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__